import React, { useEffect, useCallback, useState } from 'react';
import { Redirect } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { makeStyles } from '@material-ui/styles';
import { Tabs, Tab, Divider } from '@material-ui/core';
import { Page, Header, PdfSiglePage } from 'components';
import PropTypes from 'prop-types';

const useStyles = makeStyles((theme) => ({
	root: {
		padding: theme.spacing(3),
	},
	container: {
		marginTop: theme.spacing(1),
	},
	tabs: {
		marginTop: theme.spacing(1),
	},
	content: {
		marginTop: theme.spacing(1),
	},
}));

const PdfViewer = (props) => {
	const { pdf, filename } = props;
	const classes = useStyles();
	const dispatch = useDispatch();

	const getData = useCallback(() => {
		// dispatch();
	}, []);

	useEffect(() => {
		getData();
	}, []);

	return (
		<div className={classes.fields}>
			<PdfSiglePage pdf={pdf} filename={filename} />
		</div>
	);
};

PdfViewer.propTypes = {
	pdf: PropTypes.string.isRequired,
	filename: PropTypes.string.isRequired
};

export default PdfViewer;
